import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { CommonLayoutRoutes } from './common-layout.routing';
import { CreateAppointmentComponent } from './../../create-appointment/create-appointment.component';
import { AppointmentsComponent } from './../../appointments/appointments.component';
import { DashboardsComponent } from './../../dashboards/dashboards.component';
import { DashboardV2Component } from '../../dashboard-v2/dashboard-v2.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgChartsModule } from 'ng2-charts';



@NgModule({
  declarations: [
    DashboardsComponent,
    AppointmentsComponent,
    DashboardV2Component,
  ],
  imports: [
    CommonModule,
    NgChartsModule,
    NgxSpinnerModule,
    
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(CommonLayoutRoutes),
  ]
})
export class CommonLayoutModule { }
